export const GET_MEDIA_GALLERY = "GET_MEDIA_GALLERY"
export const IS_Media_GalleryOpen = "IS_Media_GalleryOpen"
export const SET_MEDIA_PGUID_PMEDIA = "SET_MEDIA_PGUID_PMEDIA"
